import React from 'react'
import { Bars3Icon } from '@heroicons/react/24/outline'
import { HeaderProps } from '../../../types/layout'
import { usePageTitle } from '../../../hooks/layout'
import PageTitle from './PageTitle'
import Breadcrumbs from './Breadcrumbs'
import UserMenu from './UserMenu'

/**
 * Componente principal del Header
 * Incluye breadcrumbs, título de página y menú de usuario
 */
const Header: React.FC<HeaderProps> = ({ onLogout, onMenuClick }) => {
  const { pageTitle, breadcrumbs } = usePageTitle()

  return (
    <header className="bg-white shadow-sm sticky top-0 z-40 border-b border-gray-100">
      <div className="w-full px-3 sm:px-4 lg:px-5">
        <div className="flex min-h-14 items-center justify-between gap-3 py-2">
          <div className="flex min-w-0 flex-1 items-center gap-2 sm:gap-3">
            <button
              className="lg:hidden shrink-0 text-gray-500 hover:text-gray-700 transition-all duration-200 hover:scale-110 active:scale-95"
              onClick={onMenuClick}
              aria-label="Abrir menú">
              <Bars3Icon className="h-6 w-6" />
            </button>

            <div className="min-w-0 flex flex-col gap-0.5">
              <Breadcrumbs items={breadcrumbs} />
              <PageTitle titleInfo={pageTitle} />
            </div>
          </div>

          <UserMenu onLogout={onLogout} />
        </div>
      </div>
    </header>
  )
}

export default React.memo(Header)
